/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProjectCompanyFieldRequestDto } from '../../models/backend-patched-project-company-field-request-dto';
import { BackendProjectCompanyFieldDto } from '../../models/backend-project-company-field-dto';

export interface ProjectsProjectCompanyPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedProjectCompanyFieldRequestDto;
}

export function projectsProjectCompanyPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectCompanyPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectCompanyPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectCompanyFieldDto>;
    }),
  );
}

projectsProjectCompanyPartialUpdate$FormData.PATH = '/api/projects/project_company/{id}/';
